// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1tvoG","buttons":"PendingPaymentAlert_buttons__XgxBM"};